<template>
  <div>
    <e-dialog
      :dialog-title="dialogTitle"
      :center-dialog-visible="chooseVisible"
      :popup-width="'1000px'"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
    >
      <search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></search>
      <div class="table-wrapper flex">
        <div class="table-box">
          <el-table
            ref="tableShow"
            :data="tableData"
            border
            max-height="400"
            row-key="companyId"
            @select-all="handleSelectionChange"
            @select="handleSelectionRowChange"
          >
            <el-table-column
              type="selection"
              width="45"
              align="center"
              :reserve-selection="true"
            ></el-table-column>
            <el-table-column label="序号" width="80" align="center">
              <template slot-scope="scope">
                {{
                  (queryData.pageNum - 1) * queryData.pageSize +
                  scope.$index +
                  1
                }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="selectNameFlag === 'purchaseCompanyIdList'"
              prop="companyName"
              label="采购商名称"
              align="center"
            >
              >
              <template slot-scope="scope">
                <e-tooltip :content="scope.row.companyName" :set-length="24" />
              </template>
            </el-table-column>
            <el-table-column
              v-else
              prop="companyName"
              label="公司名称"
              align="center"
            >
              <template slot-scope="scope">
                <e-tooltip :content="scope.row.companyName" :set-length="24" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="show-select-box">
          <div class="show-title flex-sb">
            <div>当前选择：{{ selectData.length }}</div>
            <div class="clear-all" @click="handleClear">全部清除</div>
          </div>
          <div class="detail-box">
            <div
              v-for="(item, index) in selectData"
              :key="item.companyId"
              class="word-show"
            >
              <div>
                <e-tooltip
                  :content="item.companyName"
                  :set-length="30"
                  style="display: inline-block"
                />
              </div>
              <img
                src="@/assets/img/close.png"
                alt=""
                class="close"
                @click="deleteFile(index, item)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total,prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import search from '@/modules/projectA/components/common/e-search';
import api from '@/modules/projectA/api/user';
import eTooltip from '@/modules/projectA/components/common/e-tooltip';

export default {
  components: { eDialog, search, eTooltip },
  props: {
    chooseVisible: Boolean,
    selectNameFlag: String,
    companyIdList: Array,
    supplierCompanyInfo: Array,
    supplierCompanyIdList: Array,
    purchaseCompanyInfo: Array,
    purchaseCompanyIdList: Array,
    companyInfo: Object,
  },
  data() {
    return {
      firstEnter: false,
      defaultSelectData: [], // 默认选中的 数据
      selectionShow: true,
      queryData: {
        itemId: '',
        companyName: '',
        pageNum: 1,
        pageSize: 10,
      },
      selectData: [],
      delData: [],
      defaultSelect: true,
      pageTotal: 0,
      dialogTitle: '',
      filterInfo: {
        data: {
          companyName: '',
        },
        count: 10,
        fieldList: [{ label: '公司名称', type: 'input', value: 'companyName' }],
        btnStyle: [{ text: '查询', type: 'primary' }, { text: '重置' }],
      },
      tableData: [],
      chooseCompanyData: {
        companyId: '',
      },
      companyId: '',
      companyName: '',
    };
  },
  mounted() {
    this.distinguishSelect();
  },
  methods: {
    handleClear() {
      this.defaultSelectData = [];
      this.selectData = [];
      this.$refs.tableShow.clearSelection();
    },
    deleteFile(index, item) {
      this.firstEnter = false;
      // 删除当前页判断有无 删除的 数据
      const whetherExist = this.tableData.filter(
        (filterItem) => filterItem.companyId === item.companyId
      );
      this.selectData.splice(index, 1);
      if (whetherExist.length > 0) {
        this.$refs.tableShow.toggleRowSelection(item, false);
      } else {
        // 不存在
        this.delData.push(item);
      }
    },
    // 默认选中操作
    handleDefault(defaultSelectData) {
      this.$nextTick(() => {
        if (defaultSelectData && defaultSelectData.length > 0) {
          // 第一次进来
          this.tableData.forEach((item) => {
            defaultSelectData.forEach((eachItem) => {
              if (eachItem.companyId === item.companyId) {
                this.$refs.tableShow.toggleRowSelection(item, true);
              }
            });
          });
          this.selectData = JSON.parse(JSON.stringify(defaultSelectData));
        } else {
          this.tableData.forEach((item) => {
            this.selectData.forEach((eachItem) => {
              if (eachItem.companyId === item.companyId) {
                this.$refs.tableShow.toggleRowSelection(item, true);
              }
            });
            this.delData.forEach((eachItem) => {
              if (eachItem.companyId === item.companyId) {
                this.$refs.tableShow.toggleRowSelection(item, false);
              }
            });
          });
          this.delData = [];
        }
      });
    },
    // 单条  行 的 选中
    handleSelectionRowChange(val, row) {
      this.firstEnter = false;
      if (this.defaultSelectData.length > 0) {
        const whetherExist = val.filter(
          (filterItem) => filterItem.companyId === row.companyId
        );
        if (whetherExist.length > 0) {
          this.selectData.push(row);
          console.log(this.selectData, ' this.selectData赋值');
        } else {
          this.selectData.forEach((item, index) => {
            if (row.companyId === item.companyId) {
              console.log('删去');
              this.selectData.splice(index, 1);
            }
          });
        }
      } else {
        this.selectData = val;
      }
    },
    // 单页整体 操作
    handleSelectionChange(val, row) {
      console.log(val, row, '单页整体 操作');
      this.firstEnter = false;
      // 本页全部删除
      if (val.length === 0) {
        this.tableData.forEach((item) => {
          this.selectData.forEach((detailItem, index) => {
            if (detailItem.companyId === item.companyId) {
              this.selectData.splice(index, 1);
            }
          });
        });
      } else {
        this.selectData = val;
      }
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryData.pageNum = 1;
      this.handleQueryData();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.handleQueryData();
    },
    submitPopupData() {
      this.$emit('handleQueryCompany', this.selectData);
      // this.selectData = [];
    },
    resetPopupData() {
      this.handleClear();
      this.companyName = '';
      this.$emit('closeDialog');
      if (this.defaultSelectData.length > 0) {
        this.$emit('handleQueryCompany', this.defaultSelectData);
      }
    },
    handleFilter(val) {
      this.queryData.companyName = val.companyName;
      this.queryData.pageNum = 1;
      this.handleQueryData();
    },
    handleReset() {
      this.queryData = {
        companyName: '',
        pageNum: 1,
        pageSize: 10,
      };
      this.handleQueryData();
    },
    // 采购商--分页查询
    async queryFirstPartyList() {
      await api.queryFirstPartyList(this.queryData).then((res) => {
        if (res.code === '200') {
          this.tableData = res.data;
          this.pageTotal = res.data.total;
        }
      });
    },
    // 供应商--分页查询
    async querySupplierList() {
      await api.queryPurchaserBySalesContact(this.queryData).then((res) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.pageTotal = res.data.total;
        }
      });
    },
    async handleQueryData() {
      if (this.selectNameFlag === 'purchaseCompanyIdList') {
        await this.queryFirstPartyList(); // 采购商--分页查询
      } else if (this.selectNameFlag === 'supplierCompanyIdList') {
        await this.querySupplierList(); // 供应商--分页查询
      }
      if (this.firstEnter) {
        this.handleDefault(this.defaultSelectData); // 还是 第一次 进页面的
      } else {
        this.handleDefault();
      }
    },
    // 区分查询  初始化 进来的 处理
    async distinguishSelect() {
      if (this.selectNameFlag === 'purchaseCompanyIdList') {
        this.dialogTitle = '采购商查询';
        this.filterInfo.fieldList[0].label = '采购商名称';
        await this.queryFirstPartyList(); // 采购商--分页查询
        if (this.purchaseCompanyInfo.length > 0) {
          this.firstEnter = true; // 第一次 进入 页面 ；有值  才 默认选中
          this.defaultSelectData = this.purchaseCompanyInfo;
        }
      } else if (this.selectNameFlag === 'supplierCompanyIdList') {
        this.dialogTitle = '供应商查询';
        this.filterInfo.fieldList[0].label = '公司名称';
        this.queryData.itemId = this.companyInfo?.itemId || '';
        this.queryData.companyName = this.companyInfo?.companyName || '';
        await this.querySupplierList(); // 供应商--分页查询

        if (this.supplierCompanyInfo.length > 0) {
          this.firstEnter = true; // 第一次 进入 页面 ；有值  才 默认选中
          this.defaultSelectData = this.supplierCompanyInfo;
        }
      }
      console.log(this.defaultSelectData, 'this.defaultSelectData');
      this.handleDefault(this.defaultSelectData);
    },
  },
};
</script>

<style scoped lang="scss">
/* @import '../../../assets/css/scrollbar.scss'; */
.table-wrapper {
  display: flex;
  .table-box {
    flex: 1;
    margin: 20px 0;
  }
  .show-select-box {
    flex: 1;
    margin: 20px 0 0 20px;
    border: 1px solid #ebeef5;
    height: 400px;
    .show-title {
      height: 36px;
      line-height: 36px;
      background-color: #f5f7fa;
      padding: 0 20px;
      margin-bottom: 10px;
    }
    .clear-all {
      color: #2d8cf0;
      cursor: pointer;
    }
    .detail-box {
      max-height: 342px;
      overflow-y: auto;
      .word-show {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 30px;
        padding: 10px 20px;
        .close {
          width: 12px;
          height: 12px;
        }
        &:hover {
          background-color: #f4f7ff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
